/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaSubmitComponentePart { 
    tmp_id?: string;
    assegnazione_scolastica_id?: string;
    form_data?: { [key: string]: any; };
}

